module.exports = "mutation ($data: UserCreate!) {\n  UserCreate(data: $data) {\n    id\n  }\n}\n"